import { render } from "./WawaTwo.vue?vue&type=template&id=ffca68d8"
import script from "./WawaTwo.vue?vue&type=script&lang=js"
export * from "./WawaTwo.vue?vue&type=script&lang=js"

import "./WawaTwo.vue?vue&type=style&index=0&id=ffca68d8&lang=css"
script.render = render

export default script